export const SAVING_ENUMS = {
  SAVED: 0,
  LOADING: 1,
  DEFAULT: 2,
};
export const ERRORS = {
  ER401: "401",
  ER500: "500",
  ER404: "404",
  NETWORKERROR: "Network Error",
  CUSTOM_TIMEOUT: "Timeout",
};
export const USER_ROLES = {
  USER: "ROLE_USER",
  ADMIN: "ROLE_ADMIN",
};
export const EVENT_STATUS = { 
  NEW: 0,
  IMPORTANT: 1,
  OLD: 2,
  EXPIRED: 3,
  IGNORE: 4
};
export const ANALYTICS_TABLES = { 
  SUMMARY: "0",
  EXPOSURE: "1"
};
export const pages_ENUMS = {
  AN: 0,
  PG: 1,
  TW: 2,
}
export const ALERT_STATUSES = {
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  UNACKNOWLEDGED: 'UNACKNOWLEDGED'
}
export const ALERT_SORTS = {
  DESC: 0,
  ASC: 1,
  NONE: 2
}
export const NOTIF_PANEL_HEIGHTS = {
  HEIGHT1: 0,
  HEIGHT2: 1,
  HEIGHT3: 2,
  DEFAULT: 3
}
export const CARD_INFO_ROW_TYPES = {
  KEY_VALUE: 0,
  TABLE: 1,
  TABS: 2
}
export const NOTIFICATION_TYPES = {
  DEFAULT: 0,
  CONNECTION: 1,
  SERVER_EVENT: 2,
  TW_ALERT: 3,
  PG_EVENT: 4,
  PERSISTENT: {
    NETWORK_ERROR: 1
  }
}
export const VISUALIZATION_TYPES = {
  CHART: "CHART",
  HISTORY_TABLE: "HISTORY_TABLE",
  LIVE_TABLE: "LIVE_TABLE"
}
export const PW_SERVER_STATUSES = {
  CONNECTED: 0,
  LOADING: 1,
  ERROR: 2,
  ERROR_404: 2,
}
export const PW_PRICE_STATUSES = {
  NEUTRAL: 0,
  DECREASE: 1,
  INCREASE: 2
}
export const LOADING_STATES = {
  DEFAULT: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3
}
export const APP_STATE_SECTIONS = {
  ANALYTICS: "analytics",
  PRICEGUARD: "priceguard",
  TRADEWATCHER: "tradewatcher",
  MUTE: "mute",
  DARK: "dark"
}